﻿$.fn.dxCtrlBcEntetePiedAppli = function custom_dxCtrlBcEntetePiedAppli(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpagebcentetepiedapplibc dx-ctrl");
        this.createInstance(new cdxCtrlBcEntetePiedAppli(this, option));
    }
    return this;
}

window.gestCognoss = null
window.cdxCtrlBcEntetePiedAppli = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    this.pop = null
    function mConstruit() {
        container.empty();

        var dxEntete = null
        var dxPied = null
        Me.pop = container.appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showTitle: true,
            width: 700,
            height: "100%",
            showMaximize: true,
            dragEnabled: false,
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            title: "Entête et pied article",
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "0px 10px 10px 40px")
                var $DivEntete = $("<div style='font-size:160%;font-weight:bold;'>Entête article</div>").appendTo(contentElement)
                dxEntete = $("<div style='height:50%;width:100%;'/>").appendTo(contentElement).dxCtrlContentEmailBase64({
                    bddCtrl: option.bddCtrl,
                    data64: option.data.entete_doc,
                    showObjetFile: false
                }).dxCtrlContentEmailBase64("instance")


                var $DivPied = $("<div style='font-size:160%;font-weight:bold;'>Pied article</div>").appendTo(contentElement)
                dxPied = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentEmailBase64({
                    bddCtrl: option.bddCtrl,
                    data64: option.data.pied_doc,
                    showObjetFile: false
                }).dxCtrlContentEmailBase64("instance")

                dxEntete.element().css("height", "calc(50% - " + ($DivEntete.innerHeight()) + "px)")
                dxPied.element().css("height", "calc(50% - " + ($DivPied.innerHeight()) + "px)")
            },
            onHiding: function (e) {
                dxEntete.mStopSaveAuto(function (base64String) {
                    if (typeof base64String != 'undefined') {
                        option.data.entete_doc = base64String
                    }
                    dxPied.mStopSaveAuto(function (base64String) {
                        if (typeof base64String != 'undefined') {
                            option.data.pied_doc = base64String
                        }
                        option.bddCtrl.getObjet(option.data).mSave()
                    })
                })
            }
        }).dxCtrlPopupBase("instance")
        Me.pop.show()

    }

    this.component = function () { return Me; }
    this.element = function () { return container; }

    mConstruit();
}